export const CHATAREA = "/";
export const COMEFUNZIONA = "/comefunziona";
export const CONTATTI = "/contatti";